export const checkForAutorolloverCDChgs = (CDList) => {
    let CDListArr = [];
    for (let i=0; i<CDList.length; i++){
        let CDListObj = CDList[i];
        if (CDListObj.autoRollover !== CDListObj.newAutoRollover){
            CDListArr.push(CDListObj);
        }
    }
    return CDListArr;
}
export default checkForAutorolloverCDChgs;